module.exports = __webpack_public_path__ + "img/lencol.07b4ded6.jpeg";